import { useCoinStore } from '../store/coinstore';
import style from './page.module.css';
import { useEffect, useState } from 'react';


export default function CoinBalance() {
    const coins = useCoinStore((state) => state.coinBalance);
    
    const totalCoins = coins.totalCoins || 0;
    const [displayBalance, setDisplayBalance] = useState(totalCoins);
    const [previousBalance, setPreviousBalance] = useState(totalCoins);

    useEffect(() => {
        // If balance increased, animate the increment
        if (totalCoins > previousBalance) {
            const difference = totalCoins - previousBalance;
            const duration = 1000; // 600ms animation duration
            const steps = Math.min(difference, 30); // Cap steps for smooth animation
            const stepDuration = duration / steps;
            const increment = difference / steps;

            let currentStep = 0;
            const animationInterval = setInterval(() => {
                currentStep++;
                const animatedValue = previousBalance + increment * currentStep;
                setDisplayBalance(Math.floor(animatedValue));

                if (currentStep >= steps) {
                    clearInterval(animationInterval);
                    setDisplayBalance(totalCoins);
                    setPreviousBalance(totalCoins);
                }
            }, stepDuration);

            return () => clearInterval(animationInterval);
        } else if (totalCoins < previousBalance) {
            // If balance decreased, just update immediately without animation
            setDisplayBalance(totalCoins);
            setPreviousBalance(totalCoins);
        }
    }, [totalCoins, previousBalance]);

    return (
        <div className={style.dfx_myBalance}>
            <div className={style.dfx_CheckMyBalance}>
                <h2>My Balance</h2>
                <p>{displayBalance}</p>
            </div>
            <div className={style.dfx_CheckMyBalanceIcon}>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src="/mybalanceCoin.webp" alt="mybalanceCoin" />
            </div>
        </div>
    )
}
